<template>
    <profile-card title="Notification Setting">

      <div class="tw-py-4 tw-px-8 tw-font-bold">Categories:</div>

      <div class="tw-relative tw-px-10 tw-py-4">
        <multiselect
                v-model="selectedCategories"
                tag-placeholder="Add this as new category"
                placeholder="Search or add an category"
                label="label"
                track-by="title"
                :options="categories"
                :multiple="true"
                :taggable="true"
                :loading="categoryLoading"
                @search-change="searchCategory"
                @select="selectCategory"
                @remove="removeCategory"
        ></multiselect>
      </div>

      <div class="tw-py-4 tw-px-8 tw-font-bold">Suburbs:</div>

      <div class="tw-relative tw-px-10 tw-py-4">

      <multiselect
                v-model="selectedSuburbs"
                tag-placeholder="Add this as new suburb"
                placeholder="Search or add an suburb"
                label="label"
                track-by="name"
                :options="suburbs"
                :multiple="true"
                :taggable="true"
                :loading="suburbLoading"
                @search-change="searchSuburb"
                @select="selectSuburb"
                @remove="removeSuburb"
        ></multiselect>

      </div>

        <div class="cp-field">
            <div class="form-row">
                <div class="form-group col">
                    <div class="my-switch-btn">
                        <div>{{switchLabel}}</div>
                        <input type="checkbox" id="notification_switch" v-model="isActive" />
                        <label for="notification_switch">Toggle</label>
                    </div>
                </div>
            </div>
        </div>

    </profile-card>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import SwitchBtn from "nice-switch-btn";

    export default {
        components: {
            Multiselect, Loading, SwitchBtn
        },
        props: [
            'notifId',
            'active',
        ],
        data() {
            return {
                categoryLoading: false,
                suburbLoading: false,
                selectedCategories: [],
                selectedSuburbs: [],
                categories: [],
                suburbs: [],
                searchTimeOut: null,
                notificationSettingId: null,
                isActive: false,
                switchLabel: "Do you want to receive notification?",
                switchUpdate: false,
            };
        },
        mounted() {

            this.notificationSettingId = this.notifId;

            if (this.isActive === this.stringToBoolean(this.active)){
                this.switchUpdate = true;
            }

            this.isActive = this.stringToBoolean(this.active);

            document.querySelector('#notification_switch').checked = this.isActive;

            this.searchCategory();
            this.getNotifSettingCategories();

            this.searchSuburb();
            this.getNotifSettingSuburbs();
        },
        methods: {
            getNotifSettingCategories: function () {
                let self = this;
                self.categoryLoading = true;
                axios({
                    method: "get",
                    url: `/api/v1/notification-setting-category/${this.notificationSettingId}/get-all-notification-setting-categories`
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.categoryLoading = false;
                            let categories = [];
                            res.data.data.forEach(element => {
                                categories.push(element.category);
                            });
                            self.selectedCategories = categories;
                        } else {
                            self.categoryLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.categoryLoading = false;
                        console.log(err);
                    });
            },
            searchCategory(query) {
                let self = this
                self.categoryLoading = true;
                axios.get(`/api/v1/search/category`, {
                    params: {query}
                })
                    .then(resp => {
                        self.categoryLoading = true;
                        self.categories = resp.data.data
                    })
                    .catch(err => {
                        self.categoryLoading = true;
                    })
            },
            selectCategory: function (category) {
                let self = this;
                self.categoryLoading = true;
                let title = category;
                if (category.title) {
                    title = category.title;
                }
                let data = {
                    title
                };
                axios({
                    method: "post",
                    url: "/api/v1/notification-setting/store-category?api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.categoryLoading = false;
                            self.$toast.success(window.text.updated_successfully);
                        } else {
                            self.categoryLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.categoryLoading = false;
                        console.log(err);
                    });
            },
            removeCategory: function (category) {
                let self = this;
                self.categoryLoading = true;
                let title = category;
                if (category.title) {
                    title = category.title;
                }
                let data = {
                    title
                };
                axios({
                    method: "post",
                    url: "/api/v1/notification-setting/destroy-category?api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.categoryLoading = false;
                            self.$toast.success(window.text.removed_successfully);
                        } else {
                            self.categoryLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.categoryLoading = false;
                        console.log(err);
                    });
            },

            getNotifSettingSuburbs: function () {
                let self = this;
                self.suburbLoading = true;
                axios({
                    method: "get",
                    url: `/api/v1/notification-setting-suburb/${this.notificationSettingId}/get-all-notification-setting-suburbs`
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.suburbLoading = false;
                            let suburbs = [];
                            res.data.data.forEach(element => {
                                suburbs.push(element.suburb);
                            });
                            self.selectedSuburbs = suburbs;
                        } else {
                            self.categoryLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.categoryLoading = false;
                        console.log(err);
                    });
            },
            searchSuburb(query) {
                let self = this
                self.suburbLoading = true
                axios.get(`/api/v1/search/suburb`, {
                    params: {query}
                }).then(resp => {
                    self.suburbLoading = false
                    self.suburbs = resp.data.data
                })
                    .catch(err => {
                        self.suburbLoading = false
                    })
            },
            selectSuburb: function (suburb) {
                let self = this;
                self.suburbLoading = true;
                let name = suburb;
                if (suburb.name) {
                    name = suburb.name;
                }
                let data = {
                    name
                };
                axios({
                    method: "post",
                    url: "/api/v1/notification-setting/store-suburb?api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.suburbLoading = false;
                            self.$toast.success(window.text.updated_successfully);
                        } else {
                            self.suburbLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.suburbLoading = false;
                        console.log(err);
                    });
            },
            removeSuburb: function (suburb) {
                let self = this;
                self.suburbLoading = true;
                let name = suburb;
                if (suburb.name) {
                    name = suburb.name;
                }
                let data = {
                    name
                };
                axios({
                    method: "post",
                    url: "/api/v1/notification-setting/destroy-suburb?api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.suburbLoading = false;
                            self.$toast.success(window.text.removed_successfully);
                        } else {
                            self.suburbLoading = false;
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        self.suburbLoadingb = false;
                        console.log(err);
                    });
            },

            updateSettingActivity: function (isActive) {
                let self = this;
                let is_active = isActive;
                let id = this.notificationSettingId;
                let data = {
                    is_active, id
                };
                axios({
                    method: "put",
                    url: "/api/v1/notification-setting/update-active-status?api_token=" + window.api_token,
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$toast.success(window.text.updated_successfully);
                        } else {
                            console.log(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            },

            stringToBoolean: function (string) {
                switch (string.toLowerCase().trim()) {
                    case "true":
                    case "yes":
                    case "1":
                        return true;
                    case "false":
                    case "no":
                    case "0":
                    case null:
                        return false;
                    default:
                        return Boolean(string);
                }
            },

        },
        watch: {
            isActive: {
                immediate: false,
                handler() {
                    if (this.switchUpdate){
                        this.$emit("input", this.isActive);
                        this.updateSettingActivity(this.isActive);
                    }else {
                        this.switchUpdate = true;
                    }

                }
            }
        }
    }
</script>

<style scoped>
    .my-switch-btn input[type="checkbox"] {
        height: 0;
        width: 0;
        visibility: hidden;
    }

    .my-switch-btn label {
        cursor: pointer;
        text-indent: -9999px;
        width: 67px;
        height: 33px;
        background: grey;
        display: block;
        border-radius: 100px;
        position: relative;
    }

    .my-switch-btn label:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 5px;
        width: 29px;
        height: 25px;
        background: #fff;
        border-radius: 90px;
        transition: 0.3s;
    }

    .my-switch-btn input:checked + label {
        background: #bada55;
    }

    .my-switch-btn input:checked + label:after {
        left: calc(100% - 5px);
        transform: translateX(-100%);
    }

    .my-switch-btn label:active:after {
        width: 40px;
    }
</style>
